import { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { axiosPath } from '@/routing/helpers/router';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import { AppInput } from '@/layout/AppComponents';
import Translator from '@/layout/components/helpers/Translator';
import wlLg6 from '@/assets/images/wl-lg6.png';

export default function RememberPasswordScreen() {
  const isMounted = useIsMounted();
  const [msg, setMsg] = useState();
  const [validationSchema] = useState(
    Yup.object().shape({
      username: Yup.string().required('Requerido'),
      email: Yup.string().required('Requerido'),
    }),
  );

  const handleSave = async (values) => {
    setMsg();
    return  await axios
      .post(axiosPath('api_r_open_rememberPassword_email', true), values)
      .finally(() => {
          if (isMounted.current) {
            setMsg(
                ReactDOMServer.renderToString(
                    <Translator
                        file="user"
                        name="user.password.reset.checkEmail"
                    />
                )
            );
        }
      })
  }

  return (
    <Container>
        <img src={wlLg6} />
        <Formik
          initialValues={{
            username: '',
            email: '',
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={validationSchema}
          onSubmit={handleSave}
        >
          {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
                <p className="text-justify">
                    <Translator
                        file="user"
                        name="user.password.reset.info"
                        isHtml
                    />
                </p>
                <AppInput
                    title={ReactDOMServer.renderToString(
                        <Translator
                            file="general"
                            name="general.user"
                        />
                    )}
                    value={values.username}
                    onChange={(v) => setFieldValue('username', v)}
                    error={errors.username}
                    name="username"
                    autoComplete="username"
                />
                <AppInput
                    title="Email"
                    value={values.email}
                    onChange={(v) => setFieldValue('email', v)}
                    error={errors.email}
                    name="email"
                />
                <button
                    type="submit"
                    className="btn-login"
                    disabled={isSubmitting}
                >
                    <Translator
                        file="user"
                        name="user.password.reset.sendEmail"
                    />
                </button>
                {msg && <div className="alert alert-success mt-3">{msg}</div>}
            </form>
          )}
        </Formik>
    </Container>
  );
}

const Container = styled.div`
    width: 300px;
    margin: 0 auto;
    padding-top: 60px;
    font-size: 14px;

    img {
        display: block;
        margin: 0 auto 20px;
        width: 250px;
    }

    .btn-login {
        border-radius: 3px;
        margin-top: 20px;
        background-color: #003d47;
        border: 1px solid #547895;
        width: 100%;
        padding: 6px;
        color: #fff;
        font-size: 15px;
    }
`;
